namespace Ir.Components.Workbook.Widgets.MapWidget {
    interface IViewModel {
        config: WorkbookConfig;
        widget: any;

        warningPopover: DevExpress.ui.dxPopover.Properties;
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        this.config = params.config as WorkbookConfig;
        this.widget = params.widget;

        let widget: MapWidget = params.widget;
        widget.set$ReportContent(componentInfo.element);
        widget.setup();

        this.warningPopover = {
            target: $(".dx-icon-warning", componentInfo.element),
            showEvent: 'dxclick',
            position: 'top',
            width: 300,
            height: 250
        }
    }
}